module.exports = __webpack_public_path__ + "images/company/rank_medal/selling_agreement_percent_rank/2_cc7b5a253bebba2ebc07a9ebca0e707c.png";